import { useEffect, useState } from 'react';
import { message } from 'antd';
import ParamsService from './ParamsService';

export default function useLocalParam(endpoint, payload) {
  const [values, setValues] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isComponentMounted, setComponentMounted] = useState(true);

  useEffect(
    () => () => {
      setComponentMounted(false);
    },
    [setComponentMounted]
  );

  useEffect(() => {
    setLoading(true);
    ParamsService.getParams(endpoint, payload)
      .then(({ data }) => {
        if (!isComponentMounted) return;
        setValues(data);
        setLoading(false);
      })
      .catch(() => {
        message.error('No se pudieron cargar algunos datos.');
      });
  }, [setLoading, endpoint, payload]);

  return [values, isLoading];
}
